
export const userAdmin = {
  profile: {
    title: "Profil információk",
    displayName: "Megjelenített név",
    email: "Email cím",
    accountCreated: "Fiók létrehozva",
    lastLogin: "Utolsó belépés",
    updateProfile: "Profil mentése",
    updating: "Frissítés...",
    notifications: "Értesítési beállítások",
    emailNotifications: "Email értesítések",
    emailNotificationsDesc: "Értesítések fogadása a megvásárolt szolgáltatásokról",
    promotionalEmails: "Promóciós emailek",
    promotionalEmailsDesc: "Értesítések fogadása promóciókról és speciális ajánlatokról",
    platformUpdates: "Platform frissítések",
    platformUpdatesDesc: "Értesítések fogadása a platform hírekről és frissítésekről",
    security: "Biztonság",
    passwordChange: "Jelszó módosítás",
    passwordChangeDesc: "Frissítse jelszavát a fiók biztonsága érdekében",
    changePassword: "Jelszó módosítása",
    logout: "Kijelentkezés",
    logoutDesc: "Kijelentkezés a fiókból",
    logoutButton: "Kijelentkezés"
  },
  dashboard: {
    welcomeTitle: "Üdvözlünk az irányítópultodon",
    welcomeDescription: "Ez a központi felületed az összes fiókodhoz kapcsolódó tevékenységhez. Innen megtekintheted és kezelheted a profilodat, vásárlásaidat, időpontjaidat, személyes videó kéréseidet és kommunikációdat az alkotókkal.",
    bespireExplanation: "Ezen a felületen kezelheted az összes tartalmat, szolgáltatást és kommunikációt, amelyet a Bespire platformon vásároltál az alkotóktól. Az összes vásárlásod, időpontod és személyes üzeneted egy helyen elérhető.",
    quickAccessTitle: "Gyors hozzáférés",
    helpSectionTitle: "Segítségre van szükséged?",
    helpSectionDescription: "Ha bármilyen kérdésed van, vagy segítségre van szükséged a fiókodhoz, nézd meg a GYIK-et vagy lépj kapcsolatba az ügyfélszolgálatunkkal.",
    faqLinkText: "Gyakran Ismételt Kérdések",
    contactLinkText: "Kapcsolat az ügyfélszolgálattal",
    faqSectionTitle: "Gyakran Ismételt Kérdések",
    faqDialogTitle: "Gyakran Ismételt Kérdések",
    menuDescriptions: {
      profil: "Személyes adatok, fiókbeállítások és értesítési beállítások kezelése",
      vásárlások: "Vásárlási előzmények megtekintése és a megvásárolt digitális tartalmakhoz való hozzáférés",
      időpontok: "Az alkotókkal egyeztetett időpontok kezelése",
      "videó kérések": "Személyes videó kérések állapotának ellenőrzése",
      kérdéseim: "Kérdések és az alkotók válaszainak megtekintése",
      workshopjaid: "A workshopok, amelyekre jegyet vásároltál"
    }
  },
  workshops: {
    title: "Workshopjaid",
    description: "Itt láthatod az összes workshopot, amelyre jegyet vásároltál.",
    upcomingWorkshops: "Közelgő workshopok",
    pastWorkshops: "Korábbi workshopok",
    noUpcomingWorkshops: "Nincsenek közelgő workshopjaid.",
    noPastWorkshops: "Nincsenek korábbi workshopjaid.",
    name: "Név",
    date: "Dátum",
    time: "Időpont",
    location: "Helyszín",
    price: "Ár",
    online: "Online",
    physical: "Helyszíni",
    attendees: "Résztvevők"
  }
};
